<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="chart_of_account.account_id && chart_of_account.account_id > 0"
                                @invoke-method="dbGetChartOfAccount(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="chart_of_account.account_id && chart_of_account.account_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('chart_of_accounts.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in chart_of_account_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != chart_of_account.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('chart_of_accounts.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_chart_of_account.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'chart_of_accounts' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                  <v-card elevation="10">
                      <v-card-text>
                        <div class="ribbon ribbon-top-right" :class="`ribbon-${chart_of_account.status_class}`"><span class="ribbon-span">{{ chart_of_account.status }}</span></div>
                        <v-form ref="formChartOfAccount">
									<v-flex xs12>
										<v-text-field
											v-focus="chart_of_account_dialog"
											v-model="chart_of_account.account_id"
											:label="`${$t('lang.account_id')} *`"
											:counter="showCounter(chart_of_account.account_id, 'chart_of_accounts.account_id')"
											:rules="ifValid('chart_of_accounts.account_id')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="chart_of_account.account_code"
											:label="`${$t('lang.account_code')} *`"
											:counter="showCounter(chart_of_account.account_code, 'chart_of_accounts.account_code')"
											:rules="ifValid('chart_of_accounts.account_code')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="chart_of_account.account_name"
											:label="`${$t('lang.account_name')} *`"
											:counter="showCounter(chart_of_account.account_name, 'chart_of_accounts.account_name')"
											:rules="ifValid('chart_of_accounts.account_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="chart_of_account.account_type"
											:label="`${$t('lang.account_type')} *`"
											:counter="showCounter(chart_of_account.account_type, 'chart_of_accounts.account_type')"
											:rules="ifValid('chart_of_accounts.account_type')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-select
											v-model="chart_of_account.is_active"
											:label="`${$t('lang.is_active')} *`"
											:items="[]"
											item-value="value"
											item-text="text"
											:rules="ifValid('chart_of_accounts.is_active')"
										></bc-select>
									</v-flex>


                            <div>
                                <h3>ChartOfAccount Details</h3>
                                <v-data-table
                                    :headers="chart_of_account_headers"
                                    :items="chart_of_account.chart_of_account_details || []"
                                    item-key="chart_of_account_detail_id"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr>
								<td>{{ props.item.account_id }}</td>
								<td>{{ props.item.account_code }}</td>
								<td>{{ props.item.account_name }}</td>
								<td>{{ props.item.account_type }}</td>
								<td>{{ props.item.is_active }}</td>
                                            <td>
                                                <v-icon @click="removeRow(props.index)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <div class="text-center">
                                    <v-btn
                                        tile
                                        color="primary"
                                        @click="addRow()">
                                        {{ $t("lang.add_more") }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'chart_of_accounts' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveChartOfAccounts">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_chart_of_account"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_chart_of_account')"
                :message="$t('lang.delete_chart_of_account_confirm')"
                @onConfirm="deleteChartOfAccounts()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_chart_of_account_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteChartOfAccountDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            chart_of_account_headers: [
                { text: this.$t("lang.account_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.account_code"), sortable: false, width: "20%" },
                { text: this.$t("lang.account_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.account_type"), sortable: false, width: "20%" },
                { text: this.$t("lang.is_active"), sortable: false, width: "20%" },
                { text: "", width: "3%", sortable: false },
            ],
            formData: {},
            chart_of_account: { chart_of_account_details: [] },
            file_name: "",
            dbGetChartOfAccount: _.debounce(this.getChartOfAccount, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchChartOfAccount", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.chart_of_account) {
                        this.chart_of_account = this.assignObj2(data.chart_of_account, this.rules_chart_of_accounts);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=chart_of_account_status&sort_by=2",
                            method: "get",
                            stateProperty: "chart_of_account_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "chart_of_accounts", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchChartOfAccount", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.chart_of_account) {
                        next((vm) => {
                            vm.chart_of_account = vm.assignObj2(data.chart_of_account, vm.rules_chart_of_accounts);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=chart_of_account_status&sort_by=2",
                                method: "get",
                                stateProperty: "chart_of_account_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "chart_of_accounts", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=chart_of_account_status&sort_by=2",
            method: "get",
            stateProperty: "chart_of_account_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_chart_of_accounts: (state) => state.chart_of_accounts.rules_chart_of_accounts,
            chart_of_account_status_options: (state) => state.settings.chart_of_account_status_options,
            chart_of_accounts: (state) => state.chart_of_accounts.chart_of_accounts,
            selectedChartOfAccount: (state) => state.chart_of_accounts.selectedChartOfAccount,
        }),
    },
    methods: {
        ...mapActions(["fetchChartOfAccount", "saveChartOfAccount", "deleteChartOfAccount", "printChartOfAccount"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.chart_of_account.chart_of_account_details) this.chart_of_account.chart_of_account_details = [];
            this.chart_of_account.chart_of_account_details.push({
                account_id: `${this.$route.params.id}`,
                quantity: "",
                sales_unit: "",
                model_number: "",
                name: "",
            });
        },
        removeRow: function(index) {
            this.chart_of_account.chart_of_account_details.splice(index, 1);
        },
        getChartOfAccount(pg_refresh = false) {
            this.startLoader();

            this.fetchChartOfAccount({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.chart_of_account) {
                    this.chart_of_account = this.assignObj2(data.chart_of_account, this.rules_chart_of_accounts);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printChartOfAccount({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.chart_of_account) {
                    if (this.dev_mode) {
                        this.file_name = data.chart_of_account.file_name;
                    } else {
                        this.$refs.print.printReport(data.chart_of_account.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveChartOfAccounts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formChartOfAccount")) {
                    let body = this.prepForm(this.chart_of_account, this.rules_chart_of_accounts);

                    this.saveChartOfAccount({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.chart_of_account) {
                            this.$router.push({ name: "chart_of_account", params: { id: data.chart_of_account.account_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { account_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveChartOfAccounts({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.chart_of_account) {
                    this.chart_of_account = this.assignObj2(data.chart_of_account, this.rules_chart_of_accounts);
                }
            });
        },
        deleteChartOfAccounts() {
            this.deleteChartOfAccount({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.$refs.delete_chart_of_account_details.close();
                    this.validationOff();
                    this.$router.push({ name: "chart_of_accounts" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
    created() {
        this.getCustomers();
    },
};
</script>
